var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"copy-button",attrs:{"title":_vm.copied ? '已复制!' : '复制'},on:{"click":_vm.copyText}},[_vm._v(" "+_vm._s(_vm.copied ? '已复制!' : '复制')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }